import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Glyphicon } from 'react-bootstrap';
import Spinner from 'react-loader';
import './index.css';

class ButtonLoader extends Component {
  static propTypes = {
    icon: PropTypes.any,
    loading: PropTypes.bool,
    spinConfig: PropTypes.object,
    spinColorDark: PropTypes.string,
    spinColorLight: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    style: PropTypes.object
  };

  static defaultProps = {
    icon: <Glyphicon glyph='heart' />,
    loading: false,
    spinConfig: {
      lines: 10,
      length: 4,
      width: 2,
      radius: 3
    },
    spinColorDark: '#444',
    spinColorLight: '#fff',
    children: <span>Submit</span>,
    style: {}
  };

  renderIcon () {
    let icon;

    if (this.props.loading) {
      const spinColor = (!this.props.bsStyle || this.props.bsStyle === 'default')
        ? this.props.spinColorDark
        : this.props.spinColorLight;

      icon = (
        <div>
          <Spinner ref='spinner' {...this.props.spinConfig} color={spinColor} loaded={false} />
        </div>
      );
    } else {
      icon = this.props.icon;
    }

    return (
      <div className='button-loader__icon'>
        {icon}
      </div>
    );
  }

  render () {
    const classList = classNames('button-loader', this.props.className);
    return (
      <Button
        onClick={this.props.onClick}
        disabled={this.props.disabled || this.props.loading}
        bsStyle={this.props.bsStyle}
        className={classList}
        type={this.props.type}
        style={this.props.style}
        bsSize={this.props.bsSize}>
        {this.renderIcon()} {this.props.children}
      </Button>
    );
  }
}

export default ButtonLoader;



// WEBPACK FOOTER //
// ./src/shared/components/auth/ButtonLoader/index.js